import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function SocialIcon(props) {
    return (
        <React.Fragment>
            <li><a href={props.sociallink}><FontAwesomeIcon icon={props.socialIcon}/></a></li>
        </React.Fragment>
    )
}